import React from 'react';
import { Button, Dialog, Link, Text, UI5Bar } from '@sba/design-system';
import useTranslation from '../../i18n/hooks/useTranslation';
import DEPRECATION_NOTICE_LINK from '../deprecation/deprecationNotice';

interface DeprecationNoticeDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function DeprecationNoticeDialog({ open, onClose }: DeprecationNoticeDialogProps) {
  const { t } = useTranslation('app-editor.header');
  const paragraphKeys = [
    'DEPRECATION_NOTICE_PARAGRAPH_1',
    'DEPRECATION_NOTICE_PARAGRAPH_2',
    'DEPRECATION_NOTICE_PARAGRAPH_3',
  ] as const;

  return (
    <Dialog
      open={open}
      headerText={t('DEPRECATION_NOTICE_TITLE')}
      state="Critical"
      onBeforeClose={onClose}
      footer={
        <UI5Bar
          design="Footer"
          slot="footer"
          endContent={
            <>
              <Button
                design="Emphasized"
                onClick={() => window.open(DEPRECATION_NOTICE_LINK, '_blank', 'noopener,noreferrer')}
              >
                {t('DEPRECATION_NOTICE_BUTTON_LINK_TEXT')}
              </Button>
              <Button design="Transparent" onClick={onClose}>
                {t('DEPRECATION_NOTICE_CLOSE_BUTTON_TEXT')}
              </Button>
            </>
          }
        />
      }
    >
      {paragraphKeys.map((key) => (
        <Text key={key} style={{ display: 'block', marginBottom: '0.75rem' }}>
          {t(key)}
        </Text>
      ))}
      <Text style={{ display: 'block', marginBottom: '0.75rem' }}>
        {t('DEPRECATION_NOTICE_PARAGRAPH_4')}
        <Link href={DEPRECATION_NOTICE_LINK} target="_blank">
          {t('DEPRECATION_NOTICE_LINK_TEXT')}
        </Link>
      </Text>
    </Dialog>
  );
}
